<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="alert alert-info"><b>Đồng bộ lại thông tin cuộc gọi</b> Lịch sử khách hàng, Chiến dịch gọi, lịch sử Ticket, cuộc gọi nhỡ</div>
        <div class="row">
          <div class="col-8">
            <form-input :model="formModel" attribute="call" :errors="formErrors" placeholder="ID của cuộc gọi cần đồng bộ"></form-input>
          </div>
          <div class="col-4">
            <button :disabled="!formModel.call" @click="sync" class="btn btn-primary ml-2">Đồng bộ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  mixins: [],
  data: function () {
    return {
      formErrors: [],
      service: "/tool/call-sync",
      autoLoad: false,
      formModel: {
        call: null,
      },
    };
  },
  methods: {
    sync: function () {
        let loader = this.$loading.show();
        this.$service({url: this.service, method: 'post', data: this.formModel}).then(response => {
          if (response.data) {
            this.$swal({
              title: this.$t('success'),
              text: 'Đã gửi yêu cầu vào call-submitted',
              icon: 'success'
            });
            this.formModel.call = null;
          } else {
            this.$swal({
              title: 'Ôi bome',
              text: 'Bị sao í',
              icon: 'error'
            });
          }
        }).catch(error => {
          if (error.response.data.message) {
            this.$swal({
              text: error.response.data.message,
              icon: 'error'
            });
          } else {
            this.formErrors = error.response.data;
          }
        }).finally(() => {
          loader.hide();
        });
    },
  },
};
</script>
